import { FilterData } from '@actions/calendar';
import { RootState } from '@reducers/index';
import { CalendarChallenge, CalendarChallengeGroupOption } from 'src/types/shared/Challenge';

export const getCalendarIsFetching = (state: RootState): boolean =>
    state.calendarReducer.isFetching;
export const getCalendarFetchError = (state: RootState): string | null =>
    state.calendarReducer.fetchError;

export const getCalendarChallenges = (state: RootState): Record<number, CalendarChallenge> =>
    state.calendarReducer.calendarChallenges;

export const getAllCalendarChallengeGroupOptions = (
    state: RootState,
): CalendarChallengeGroupOption[] => state.calendarReducer.allChallengeGroupOptions;
export const getMyCalendarChallengeGroupOptions = (
    state: RootState,
): CalendarChallengeGroupOption[] => state.calendarReducer.myChallengeGroupOptions;

export const getCalendarFilterData = (state: RootState): FilterData =>
    state.calendarReducer.calendarFilterData;
